/**
 * Message Type that can be sent to a ChargePoint
 */
export enum ResetType {
    HARD = 'HARD',
    SOFT = 'SOFT'
}
